import script from "./Main-Image-Library.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-Image-Library.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__